












import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'
import { Contact } from '@/modules/Contact/interfaces/contact'
import S3Handler from '@/mixins/s3'

@Component({
  components: {
    AppAttachmentsCard
  }
})
export default class ContactDetailContact extends mixins(S3Handler) {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  get attachmentList () {
    return this.contact.attachments || []
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
